import request from '#/utils/request';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

/**
 * DELETE `/fms/vouchers/{id}`。
 * 僅 DRAFT；成功 **204** No Content — 不 parse body。
 */
export async function deleteDraftVoucher(id) {
  const res = await request.delete(`/fms/vouchers/${id}`);
  if (res.status === 204 || res.data == null || res.data === '') {
    return { data: null };
  }
  return parseVer4DetailResponse(res.data);
}
